import React from "react";

const CampusIRALoader = ({ isExiting }) => {
  const letters = "CampusIRA".split("");

  return (
    <div
      className={`fixed inset-0 flex flex-col items-center justify-center bg-white z-[9999] transition-opacity duration-700 ${
        isExiting ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div className="flex space-x-1">
        {letters.map((char, index) => (
          <span
            key={index}
            className="text-5xl md:text-7xl font-black text-blue-600 animate-bounce inline-block"
            style={{
              animationDelay: `${index * 0.1}s`,
              animationDuration: "1s",
            }}
          >
            {char}
          </span>
        ))}
      </div>

      <div className="mt-10 flex flex-col items-center">
        <div className="w-48 h-1.5 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-blue-600 animate-loading-bar shadow-[0_0_10px_rgba(37,99,235,0.5)]"></div>
        </div>
        <p className="mt-4 text-gray-400 tracking-[0.4em] text-[10px] uppercase font-bold">
          Initializing CampusIRA
        </p>
      </div>

      <style jsx>{`
        @keyframes loading-bar {
          0% { width: 0%; transform: translateX(-100%); }
          50% { width: 100%; transform: translateX(0%); }
          100% { width: 0%; transform: translateX(100%); }
        }
        .animate-loading-bar {
          animation: loading-bar 2s infinite ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default CampusIRALoader;